import { useState, useEffect } from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { raisValidity } from "../../api/validity";

const GiftForm = ({ setStatus, setShowNotification }) => {
  const [loading, setLoading] = useState(false);
  const [fieldTouched, setFieldTouched] = useState(false);
  const [initialValues, setInitialValues] = useState({
    phone: "",
    credit: 0,
    description: "",
  });

  const handleSendGift = async (values, { resetForm }) => {
    try {
      const formData = {};
      formData.phone = values.phone;
      formData.credit = values.credit;
      formData.description = values.description;

      const res = await raisValidity(formData);

      setStatus(res.status);
      setShowNotification(true);
      resetForm();
    } catch (err) {
      alert("مشکل در ارسال هدیه");
    }
  };

  const validationSchema = Yup.object({
    phone: Yup.string().required("شماره تماس اجباری می باشد"),
    credit: Yup.number("باید عدد باشد").required("مقدار اعتبار اجباری می باشد"),
    description: Yup.string().required("اضافه کردن توضیحات اجباری می باشد"),
  });

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={handleSendGift}
      validationSchema={validationSchema}
    >
      {({ values, errors, touched, handleSubmit, handleChange }) => (
        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-lg w-full p-4 md:p-8 space-y-4 md:space-y-6"
        >
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4 sm:mb-6">
            هدیه اعتبار
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6"></div>
          {/* شماره تماس */}
          <div className="col-span-full">
            <label
              htmlFor="title"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              شماره تماس
            </label>
            <input
              type="text"
              id="phone"
              name="phone"
              className="w-full px-3 py-2 sm:px-4 sm:py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
              placeholder="شماره تماس را وارد کنید...."
              onChange={handleChange}
              onBlur={() => setFieldTouched("phone")}
              value={values.phone}
            />
            {touched.phone && errors.phone && (
              <p className="mt-1 text-xs text-red-600">*{errors.phone}</p>
            )}
          </div>
          {/* تعداد اعتبار */}
          <div className="col-span-full">
            <label
              htmlFor="title"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              مقدار اعتبار
            </label>
            <input
              type="number"
              id="credit"
              name="credit"
              className="w-full px-3 py-2 sm:px-4 sm:py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
              placeholder="مقدار اعتبار را وارد کنید..."
              onChange={handleChange}
              onBlur={() => setFieldTouched("credit")}
              value={values.credit}
            />
            {touched.credit && errors.credit && (
              <p className="mt-1 text-xs text-red-600">*{errors.credit}</p>
            )}
          </div>
          {/* توضیحات*/}
          <div className="col-span-full">
            <label
              htmlFor="title"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              توضیحات
            </label>
            <input
              type="text"
              id="description"
              name="description"
              className="w-full px-3 py-2 sm:px-4 sm:py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
              placeholder="توضیحات"
              onChange={handleChange}
              onBlur={() => setFieldTouched("description")}
              value={values.description}
            />
            {touched.description && errors.description && (
              <p className="mt-1 text-xs text-red-600">*{errors.description}</p>
            )}
          </div>
          {/* دکمه ارسال */}
          <div className="mt-6 flex justify-between ">
            <button
              type="submit"
              disabled={loading}
              className="w-full sm:w-auto px-4 py-2 sm:px-6 sm:py-3 bg-blue-600 text-white text-sm sm:text-base font-medium rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-200 transition duration-200 disabled:opacity-50"
            >
              {loading ? "در حال ارسال..." : "ثبت هدیه"}
            </button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default GiftForm;
